module.exports = __webpack_public_path__ + "media/customizations/sterlingranch/logo-new-5078c31f97ffed165901643e089d7d5e.png";